import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, useTheme, RadioGroup, FormControlLabel, Radio,
} from "@mui/material";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import axiosInstance from "../../../../lib/axios";
import LocationCityIcon from '@mui/icons-material/LocationCity';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';

const MultiStUpDlog = ({
  open,
  onClose,
  tickets,
  propName,
  assignBy,
  setSelectedRows,
  setSelectedCategoryId,
  fetchCardData,
  fetchTickets
}) => {
  const theme = useTheme();
  const [status, setStatus] = useState("resolved");

  const labelCell = (icon, text) => (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      {icon}
      <Typography variant="body1" sx={{ fontWeight: 700 }}>
        {text}
      </Typography>
    </Box>
  );

  const handleSubmit = async () => {
    try {
      const statusMap = {
        hold: "H",
        resolved: "R",
        closed: "C",
        inpro: "I",
      };

      const payload = tickets.map((ticket) => ({
        TicketId: ticket.TicketId,
        TicketSt: statusMap[status] || "R",
        Flag: "",
      }));

      const response = await axiosInstance.post(
        "/TrnTicketing/TrnTicketSt",
        payload
      );

      const { Status, Message } = response.data;

      if (Status === 0) {
        toast.success(Message || "Tickets updated successfully.");

        setSelectedRows([]);
        setSelectedCategoryId(null);
        fetchTickets();
        fetchCardData();
        onClose();
      } else {
        toast.error(Message || "Failed to update tickets.");
      }
    } catch (error) {
      toast.error(
        error.response?.data?.Message || "Error updating tickets. Please try again.",
      );
    }
  };

  const handleCancel = () => {
    if (typeof setSelectedRows === "function") {
      setSelectedRows([]);
    }
    if (typeof setSelectedCategoryId === "function") {
      setSelectedCategoryId(null);
    }
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          overflow: 'hidden',
          boxShadow: 6,
        },
      }}
    >
      <DialogTitle
        sx={{
          pt: 1,
          pb: 1,
          px: 2,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontWeight: 'bold',
          fontSize: { xs: '1.2rem', sm: '1.6rem' },
          background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
          color: '#fff',
        }}
      >
        Update Multiple Tickets Status
      </DialogTitle>

      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <LocationCityIcon color="primary" fontSize="small" />
            <Typography variant="body1" sx={{ fontWeight: 700 }}>
              Property:
            </Typography>
            <Typography variant="body1">{propName || "N/A"}</Typography>
          </Box>

          {/* Status */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Box
              sx={{
                py: { xs: '2px', sm: '4px', md: '6px' },
                px: { xs: '2px', sm: '4px', md: '6px' },
                minWidth: { xs: '30%', sm: '20%' },
                maxWidth: { xs: '40%', sm: '25%' },
                boxSizing: 'border-box',
              }}
            >
              {labelCell(
                <AssignmentTurnedInIcon color="primary" sx={{ fontSize: { xs: '1rem', sm: '1.1rem', md: '1.3rem' } }} />,
                'Status'
              )}
            </Box>
            <Box>
              <RadioGroup
                row
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                sx={{ fontSize: { xs: '0.9rem', sm: '0.85rem', md: '1rem' } }}
              >
                <FormControlLabel
                  value="hold"
                  control={<Radio size="small" />}
                  label="Hold"
                  sx={{ mr: { xs: 0.5, sm: 1 } }}
                />
                <FormControlLabel
                  value="inpro"
                  control={<Radio size="small" />}
                  label="In-Progress"
                  sx={{ mr: { xs: 0.5, sm: 1 } }}
                />
                <FormControlLabel
                  value="resolved"
                  control={<Radio size="small" />}
                  label="Resolved"
                  sx={{ mr: { xs: 0.5, sm: 1 } }}
                />
                <FormControlLabel
                  value="closed"
                  control={<Radio size="small" />}
                  label="Closed"
                />
              </RadioGroup>
            </Box>
          </Box>
        </Box>
      </DialogContent>

      <DialogActions sx={{ mr: { xs: '0px', sm: '0px', md: '15px' } }}>
        <Button
          onClick={handleSubmit}
          color="primary"
          variant="contained"
          sx={{
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 'bold',
            px: 4,
            fontSize: { xs: '0.99rem', sm: '1rem' },
          }}
        >
          Submit
        </Button>
        <Button
          onClick={handleCancel}
          color="error"
          variant="outlined"
          sx={{
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 'bold',
            px: 4,
            fontSize: { xs: '0.99rem', sm: '1rem' },
          }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MultiStUpDlog;